<app-page-body>
  <!-- header -->
  <app-page-header
    [title]="'pages.contacts.importfromfile.title'"
    [isForm]="true"
    [loading]="loading"
    (onBack)="onClose()"
    (onRefresh)="onReset()"
    [showRefreshBtn]="false"
  >
  </app-page-header>

  <!-- content -->
  <div class="app-page-content">
    <form autocomplete="off" [formGroup]="form">
      <div class="row tw-flex tw-px-3">
        <fieldset class="tw-mb-1">
          <legend>
            {{ fields + "phonebookGroup" | translate }}
          </legend>
          <div class="sm:tw-w-1/2">
            <form-field
              [(value)]="phonebookTitle"
              [control]="form?.get('phonebook')"
              [label]="fields + 'phonebookGroup' | translate"
            >
            </form-field>
          </div>
        </fieldset>

        <fieldset class="tw-mb-2">
          <legend>
            {{
              "pages.contacts.importfromfile.legends.importFromFile" | translate
            }}
          </legend>
          <div class="sm:tw-w-1/2">
            <file-uploader
              [label]="fields + 'selectfile'"
              [control]="form?.get('inputFile')"
              class="tw-w-[275px]"
              (valueChange)="readFileAndCreateInMemoryData($event)"
              (onClearFile)="previewModel = null"
              acceptFile=".xls,.xlsx,.csv"
              [maxFileSize]="100"
              [progress]="progress"
              sizeType="mb"
              (onErrorFile)="showErrorDialog($event)"
            >
            </file-uploader>
          </div>
          <div class="row">
            <div class="md:tw-w-1/2">
              <custom-select-search
                *ngIf="!this.loading && this.jsonData != null"
                class="tw-w-full"
                [label]="fields + 'cellPhone'"
                [items]="finalImportedColList"
                optionTitle="value"
                optionValue="value"
                [removable]="false"
                [control]="form?.get('mobileFieldName')"
                [(value)]="cellPhoneFieldName"
                (valueChange)="getPattern('CellPhone', $event)"
              >
              </custom-select-search>
            </div>

            <div class="md:tw-w-1/2">
              <custom-select-search
                *ngIf="!this.loading && this.jsonData != null"
                class="tw-w-full"
                [label]="fields + 'firstNameFieldName'"
                [items]="finalImportedColList"
                optionTitle="value"
                optionValue="value"
                [removable]="false"
                [(value)]="firstNameFieldName"
                (valueChange)="getPattern('FirstName', $event)"
              >
              </custom-select-search>
            </div>

            <div class="md:tw-w-1/2">
              <custom-select-search
                *ngIf="!this.loading && this.jsonData != null"
                class="tw-w-full"
                [label]="fields + 'lastNameFieldName'"
                [items]="finalImportedColList"
                optionTitle="value"
                optionValue="value"
                [removable]="false"
                [(value)]="lastNameFieldName"
                (valueChange)="getPattern('LastName', $event)"
              >
              </custom-select-search>
            </div>

            <div class="md:tw-w-1/2">
              <custom-select-search
                *ngIf="!this.loading && this.jsonData != null"
                class="tw-w-full"
                [label]="fields + 'emailFieldName'"
                [items]="finalImportedColList"
                optionTitle="value"
                optionValue="value"
                [removable]="false"
                [(value)]="emailFieldName"
                (valueChange)="getPattern('Email', $event)"
              >
              </custom-select-search>
            </div>

            <div class="md:tw-w-1/2">
              <custom-select-search
                *ngIf="!this.loading && this.jsonData != null"
                class="tw-w-full"
                [label]="fields + 'telephoneFieldName'"
                [items]="finalImportedColList"
                optionTitle="value"
                optionValue="value"
                [removable]="false"
                [(value)]="telephoneFieldName"
                (valueChange)="getPattern('Telephone', $event)"
              >
              </custom-select-search>
            </div>

            <div class="md:tw-w-1/2">
              <custom-select-search
                *ngIf="!this.loading && this.jsonData != null"
                class="tw-w-full"
                [label]="fields + 'jobFieldName'"
                [items]="finalImportedColList"
                optionTitle="value"
                optionValue="value"
                [removable]="false"
                [(value)]="jobFieldName"
                (valueChange)="getPattern('Job', $event)"
              >
              </custom-select-search>
            </div>

            <div class="md:tw-w-1/2">
              <custom-select-search
                *ngIf="!this.loading && this.jsonData != null"
                class="tw-w-full"
                [label]="fields + 'addressFieldName'"
                [items]="finalImportedColList"
                optionTitle="value"
                optionValue="value"
                [removable]="false"
                [(value)]="addressFieldName"
                (valueChange)="getPattern('Address', $event)"
              >
              </custom-select-search>
            </div>
          </div>
          <div class="row">
            <ng-container *ngIf="!this.loading && this.jsonData != null">
              <div
                class="md:tw-w-1/2"
                *ngFor="let customfiled of input_customFields"
              >
                <custom-select-search
                  class="md:tw-w-1/2"
                  [label]="customfiled.nameFa"
                  [items]="finalImportedColList"
                  optionTitle="value"
                  optionValue="value"
                  [removable]="false"
                  [value]="customfiled.nameEn"
                  (valueChange)="
                    createOrUpdateCustomFieldMap(customfiled.nameEn, $event);
                    getPattern(customfiled.nameEn, $event)
                  "
                >
                </custom-select-search>
              </div>
            </ng-container>
          </div>
        </fieldset>
      </div>

      <section *ngIf="!formPageConfig.isEditMode" class="tw-mt-4">
        <app-delete-contact-by-cellphone
          [form]="form"
          (phonebookIdsModel)="deletePhonebookIdsModel = $event"
        >
        </app-delete-contact-by-cellphone>
      </section>

      <fieldset *ngIf="previewModel && previewModel.length !== 0">
        <legend>
          {{ "pages.contacts.importfromfile.legends.previewFile" | translate }}
        </legend>

        <div class="row row-table">
          <!-- table -->
          <div class="tw-w-full">
            <div>
              <div
                class="tw-mb-2 items-table tw-px-0 tw-mt-4 tw-relative table-responsive"
              >
                <table
                  class="table table-striped-even table-head-custom table-vertical-center overflow-auto"
                >
                  <thead>
                    <tr class="fw-bold fs-6 tw-text-gray-800">
                      <th *ngFor="let item of importedColList">
                        {{ item }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let item of previewModel; let i = index">
                      <td *ngFor="let item of importedColList; let z = index">
                        {{ previewModel[i][z] }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </fieldset>

      <!-- form btns-->
      <app-form-btns
        [loading]="loading"
        [isDisabled]="isDisabledSubmit"
        [form]="form"
        [isEdit]="false"
        (onClose)="onClose()"
        (onSubmit)="onSubmit()"
      >
      </app-form-btns>
    </form>
  </div>
</app-page-body>
